import React from 'react'
import PropTypes from 'prop-types'
import Font from '@cred/react-font'
import defaultStyles from './themes/default/styles.module.scss'
import fox1 from './themes/fox1/styles.module.scss'
import thebalance1 from './themes/thebalance1/styles.module.scss'
import investopedia1 from './themes/investopedia1/styles.module.scss'
import forbes1 from './themes/forbes1/styles.module.scss'
import withStyles from '@cred/react-theme'

/**
 * @visibleName CTA Button
 */
const CtaButton = compProps => {
  const {
      href,
      primary,
      transparent,
      blank,
      fullWidth,
      className,
      small,
      disabled,
      onClick,
      rel,
      navigate,
      analytics,
      match,
      location,
      history,
      staticContext,
      analyticsContexts,
      analyticsOptions,
      overwriteContexts,
      styles = defaultStyles,
      dispatch,
      controlFormData,
      formName,
      ...props
    } = compProps,
    cls = [styles.cta],
    onClickHandler = proxy => {
      const {onClick, disabled} = compProps

      if (onClick) {
        const additionalEventData = {disabled}

        onClick(proxy, additionalEventData)
      }
    }

  props.target = blank ? '_blank' : '_self'

  if (className) {
    cls.push(className)
  }

  if (primary) {
    cls.push(styles.primary)
  } else {
    cls.push(styles.secondary)
  }

  if (transparent) {
    cls.push(styles.transparent)
  }

  if (fullWidth) {
    cls.push(styles.fullWidth)
  }

  if (small) {
    cls.push(styles.small)
  }

  if (disabled) {
    cls.push(styles.disabled)
  }

  return href ?
    <Font element="a" weight="semiBold"
      href={href}
      onClick={onClickHandler}
      className={cls.join(' ')}
      rel={rel}
      {...props}
    />
    :
    <Font element="button" weight="semiBold"
      onClick={onClickHandler}
      className={cls.join(' ')}
      {...props}
    />
}

CtaButton.propTypes = {
  primary: PropTypes.bool,
  transparent: PropTypes.bool,
  fullWidth: PropTypes.bool,
  blank: PropTypes.bool,
  small: PropTypes.bool,
  rel: PropTypes.string,
  disabled: PropTypes.bool,
  history: PropTypes.object,
  styles: PropTypes.object
}

CtaButton.defaultProps = {
  primary: true,
  transparent: false,
  fullWidth: false,
  blank: false,
  small: false,
  rel: '',
  disabled: false,
  history: {}
}

CtaButton.displayName = 'CtaButton'

export {CtaButton as CtaButtonNoHoc}

export default withStyles(
  defaultStyles, {
    fox1,
    thebalance1,
    investopedia1,
    forbes1
  }
)(CtaButton)
